export default {
  apiKey: "AIzaSyDsVZdbYKi9Vea1pz16HfmuZM8jsKfx5GQ",
  authDomain: "castablog.com",
  databaseURL: "https://textcast-16d99.firebaseio.com",
  projectId: "textcast-16d99",
  storageBucket: "textcast-16d99.appspot.com",
  messagingSenderId: "591526523798"
}



// WEBPACK FOOTER //
// ./src/firebase-creds.ts